import { SET_CHEQUE, SET_CHEQUES } from "../../constants/chequeConstants";

export const setCheque = (cheque) => {
  return {
    type: SET_CHEQUE,
    cheque,
  };
};

export const setCheques = (cheques, filtered = false) => {
  return {
    type: SET_CHEQUES,
    cheques,
    filtered,
  };
};
